// extracted by mini-css-extract-plugin
export var noSpinners = "_sl-6";
export var percentageInput = "_sl-7";
export var variantColor1 = "_sl-0";
export var variantColor2 = "_sl-1";
export var variantColor3 = "_sl-2";
export var variantColor4 = "_sl-3";
export var variantColor5 = "_sl-4";
export var variantColor6 = "_sl-5";